import { UserState } from '@common/redux/reducers/UserReducer';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { agencyActions } from '../../modules/Actions';

export interface AgencyUserInfo extends UserState {
  classCd?: string;
  postFlg?: string;
  postCd?: string;
  proxyloginowner?: string;
}

export const initialState: AgencyUserInfo = {
  crewCd: '',
  crewName: '',
  stores: [],
  browsableStores: [],
  isLoggedIn: false,
  classCd: '',
  postCd: '',
};

export const AgencyUserReducer = reducerWithInitialState(initialState)
  .case(agencyActions.loginUser.updateUser, (state: AgencyUserInfo, payload: AgencyUserInfo) => {
    return {
      ...payload,
      isLoggedIn: state.isLoggedIn,
    };
  })
  .case(agencyActions.updateLogInStatus, (state: AgencyUserInfo, payload: boolean) => {
    return {
      ...state,
      isLoggedIn: payload,
    };
  })
  .case(agencyActions.loginAgencyUser.updateAgencyUser, (state: AgencyUserInfo, payload: AgencyUserInfo) => {
    return {
      ...state,
      ...payload,
    };
  });
